import './AppButton.css';

function AppButton({ className = '' }) {
  return (
    <a className={`app-button ${className}`} href="/#download" aria-label="Get the app">
      <svg className="apple-mark" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M16.7 12.8c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.2-1.8-1.4-.1-2.6.8-3.3.8-.7 0-1.8-.8-3-.8-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.2.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.6 1.3-2.7 0-.1-2.8-1.1-2.8-3.6Z" />
        <path d="M14.5 6.1c.6-.7 1-1.7.9-2.7-.9 0-2 .6-2.6 1.3-.6.7-1.1 1.7-1 2.7 1 .1 2-.5 2.7-1.3Z" />
      </svg>
      <span>Get the app</span>
    </a>
  );
}

export default AppButton;
